import styled from 'styled-components';
import {injectAdaptive} from 'ui/theme';

interface ColorProps {
  color?: string;
}

interface TextProps extends ColorProps {
  dense?: boolean;
}

interface ShoutProps extends ColorProps {
  thin?: boolean;
}

export const Text = styled.div<TextProps>`
  line-height: ${(p) => (p.dense ? 1.2 : 1.4)};
  ${(p) => p.color === 'grey' && `color: ${p.theme.grey}`}
`;

export const Shout = styled.div<ShoutProps>`
  padding: 0;
  ${injectAdaptive('padding-bottom', ['4px', '4px', '8px', '8px', '8px'])}
  ${injectAdaptive('font-size', ['55px', '59px', '63px', '68px', '72px'])}
  font-weight: ${(p) => (p.thin ? 400 : 700)};
  line-height: 0.8;

  ${(p) =>
    (p.color === 'red' && `color: ${p.theme.red}`) ||
    (p.color === 'grey' && `color: ${p.theme.grey}`) ||
    (p.color === 'green' && `color: ${p.theme.green}`)}
`;
